import { render, staticRenderFns } from "./StrongInputBirthdayPanel.vue?vue&type=template&id=58fcef7d&"
import script from "./StrongInputBirthdayPanel.vue?vue&type=script&lang=js&"
export * from "./StrongInputBirthdayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports